import { IState } from 'legacy/lut/store'

export const selectLandingState = (state: IState) => state.partner360.landing
